import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ObsOutput from "@/pages/ObsOutput";
import ConsoleLayout from "@/pages/console/ConsoleLayout";
import Dashboard from "@/pages/console/Dashboard";
import StreamPage from "@/pages/console/StreamPage";
import Billing from "@/pages/console/Billing";
import Support from "@/pages/console/Support";
import Settings from "@/pages/console/Settings";
import Admin from "@/pages/console/Admin";
import PaymentCallback from "@/pages/PaymentCallback";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ForgotPassword from "@/pages/ForgotPassword";

const TOAST_OPTIONS = {
    style: {
        background: "#121212",
        border: "1px solid rgba(255,255,255,0.1)",
        color: "#fff",
        borderRadius: 0,
        fontFamily: "JetBrains Mono, monospace",
        fontSize: "12px",
    },
};

function AppRouter() {
    const location = useLocation();
    // Handle Google OAuth callback synchronously during render (prevents race conditions)
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/obs" element={<ObsOutput />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route
                path="/console"
                element={
                    <ProtectedRoute>
                        <ConsoleLayout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Dashboard />} />
                <Route path="stream" element={<StreamPage />} />
                <Route path="billing" element={<Billing />} />
                <Route path="support" element={<Support />} />
                <Route path="settings" element={<Settings />} />
                <Route path="admin" element={<Admin />} />
            </Route>
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                </AuthProvider>
            </BrowserRouter>
            <Toaster theme="dark" position="bottom-right" toastOptions={TOAST_OPTIONS} />
        </div>
    );
}

export default App;
